import { selectEntityStatus } from "../ui/ui.selectors";
import { VIRTUAL_TRYON } from "./virtual-tryon.reducer";

export const selectVirtualTryOn = (state) => state[VIRTUAL_TRYON];
export const selectVirtualTryOnStatus = (state) =>
    selectEntityStatus(state, VIRTUAL_TRYON);
